<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-dashboard mr-2" />Dashboard Inventori</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filter.sku"
                            type="search"
                            id="filterInput"
                            placeholder="SKU"
                            @keyup.enter="getItems"
                        />
                        <multiselect v-model="filter.kategori"
                            class="mr-2"
                            :options="optKategori"
                            :allow-empty="true"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Kategori"
                        />
                        <b-form-input class="mr-2"
                            v-model="filter.model"
                            type="search"
                            placeholder="Model"
                            @keyup.enter="getItems"
                        />
                        <b-form-input class="mr-2"
                            v-model="filter.ukuran"
                            type="search"
                            placeholder="Ukuran"
                            @keyup.enter="getItems"
                        />
                        <b-form-input class="mr-2"
                            v-model="filter.warna"
                            type="search"
                            placeholder="Warna"
                            @keyup.enter="getItems"
                        />
                    </div>
                </b-form-group>
            </div>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Sortir"
                    label-for="sortir"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-select class="ml-2 mr-2" v-model="filter.sort" :options="optSort">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Sortir...</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search" />
                        </b-button>
                    </div>
                </b-form-group>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada inventori.
                </template>
                <template v-slot:cell(foto)="row">
                    <div v-if="row.item.foto == null">No Photo</div>
                    <a v-else :href="$BASE_FILE_PATH + row.item.foto" target="_blank">
                        <img :src="$BASE_FILE_PATH + row.item.foto" height="40" />
                    </a>
                </template>
                <template v-slot:cell(model)="row">
                    {{ row.item.model }}
                    <div class="small text-muted">{{ row.item.kategori }}</div>
                </template>
                <template v-slot:cell(harga)="row">
                    Rp. {{ $helper.formatThousandSeparator(row.item.harga) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button class="mr-2" size="sm" variant="primary" @click="openLogStokModal(row.item)">
                        <i class="fa fa-fw fa-clipboard" />
                    </b-button>
                    <b-button class="mr-2" size="sm" variant="success" @click="openTambahKurangModal(row.item, 'tambah')">
                        <i class="fa fa-fw fa-plus" />
                    </b-button>
                    <b-button size="sm" variant="danger" @click="openTambahKurangModal(row.item, 'kurang')">
                        <i class="fa fa-fw fa-minus" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
        <DashboardLogModal :item="activeItem" />
        <b-modal id="modal-tambah" title="Tambah Stok"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputJumlahTambah.focus()"
        >
            Penambahan untuk:
            <div>Model <strong>{{ activeItem.model }}</strong></div>
            <div>Ukuran <strong>{{ activeItem.ukuran }}</strong></div>
            <div>Warna <strong>{{ activeItem.warna }}</strong></div>
            <div class="mb-3">Stok sekarang: {{ activeItem.stok }}</div>
            <b-form-group label="Jumlah">
                <b-form-input ref="inputJumlahTambah" type="number" v-model="input.jumlah" maxlength="10" />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-input v-model="input.keterangan" placeholder="Opsional. Max 100 huruf." />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInputTambah">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-kurang" title="Kurangi Stok"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputJumlahKurang.focus()"
        >
            Pengurangan untuk:
            <div>Model <strong>{{ activeItem.model }}</strong></div>
            <div>Ukuran <strong>{{ activeItem.ukuran }}</strong></div>
            <div>Warna <strong>{{ activeItem.warna }}</strong></div>
            <div class="mb-3">Stok sekarang: {{ activeItem.stok }}</div>
            <b-form-group label="Jumlah">
                <b-form-input ref="inputJumlahKurang" type="number" v-model="input.jumlah" maxlength="10" />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-input v-model="input.keterangan" placeholder="Opsional. Max 100 huruf." />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInputKurang">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DashboardLogModal from '@/views/modals/DashboardLogModal'

export default {
    name: 'dashboard',
    components: {
        DashboardLogModal
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            input: {
                jumlah: null,
                keterangan: ""
            },

            filter: {
                sku: "",
                model: "",
                ukuran: "",
                warna: "",
                sort: 1,
                kategori: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "foto", label: "Foto" },
                { key: "sku", label: "SKU" },
                { key: "model", label: "Model" },
                { key: "ukuran", label: "Ukuran" },
                { key: "warna", label: "Warna" },
                { key: "harga", label: "Harga" },
                { key: "stok", label: "Stok" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optKategori: [],
            optSort: [
                { text: "Model A - Z", value: 1 },
                { text: "Model Z - A", value: 2 },
                { text: "Stok Rendah ke Tinggi", value: 3 },
                { text: "Stok Tinggi ke Rendah", value: 4 },
                { text: "Warna A - Z", value: 5 },
                { text: "Warna Z - A", value: 6 },
                { text: "Harga Rendah ke Tinggi", value: 7 },
                { text: "Harga Tinggi ke Rendah", value: 8 }
            ]

        }
    },
    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getKategoriOpt = this.$axios.get("kategori/").then(res => {
                this.optKategori = res.data
            })

            Promise.all([getItems, getKategoriOpt]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&sortBy=" + this.filter.sort

            if(!this.$helper.isBlank(this.filter.sku)) {
                param += "&filterSku=" + this.filter.sku
            }

            if(!this.$helper.isBlank(this.filter.kategori)) {
                param += "&filterKategoriId=" + this.filter.kategori.id
            }

            if(!this.$helper.isBlank(this.filter.model)) {
                param += "&filterModel=" + this.filter.model
            }

            if(!this.$helper.isBlank(this.filter.ukuran)) {
                param += "&filterUkuran=" + this.filter.ukuran
            }

            if(!this.$helper.isBlank(this.filter.warna)) {
                param += "&filterWarna=" + this.filter.warna
            }

            // Execute
            return this.$axios.get("warna/gudang/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        openTambahKurangModal(item, id) {

            this.activeItem = item
            this.$bvModal.show("modal-" + id)

        },

        openLogStokModal(item) {

            this.activeItem = item
            this.$bvModal.show("modal-log-stok")

        },

        executeInputTambah() {

            if(this.$helper.isBlank(this.input.jumlah)) {
                return this.$helper.toastError(this, "Jumlah tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("warnaId", this.activeItem.id)
            payload.append("jumlah", this.input.jumlah)

            if(!this.$helper.isBlank(this.input.keterangan)) {
                payload.append("keterangan", this.input.keterangan)
            }

            this.isSubmitting = true
            this.$axios.post("warna/tambah", payload).then(res => {

                this.activeItem.stok += res.data.id
                this.$helper.toastSuccess(this, "Stok berhasil ditambahkan!")
                this.$bvModal.hide("modal-tambah")

                this.input.jumlah = null
                this.input.keterangan = ""

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeInputKurang() {

            if(this.$helper.isBlank(this.input.jumlah)) {
                return this.$helper.toastError(this, "Jumlah tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("warnaId", this.activeItem.id)
            payload.append("jumlah", this.input.jumlah)

            if(!this.$helper.isBlank(this.input.keterangan)) {
                payload.append("keterangan", this.input.keterangan)
            }

            this.isSubmitting = true
            this.$axios.post("warna/kurang", payload).then(res => {

                this.activeItem.stok -= res.data.id
                this.$helper.toastSuccess(this, "Stok berhasil dikurangi!")
                this.$bvModal.hide("modal-kurang")

                this.input.jumlah = null
                this.input.keterangan = ""

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        }

    },
    created() {
        this.init()
    }
}
</script>
